import React from 'react';
import { Card, Input } from 'ui';
import { StyledFileUploadCard } from './style';
import { useIntl } from 'react-intl';

export const FileUploadCards = ({
  fileList,
  handleRemove,
  submitAttachment,
}: {
  fileList: any[];
  handleRemove: (file: any) => void;
  start?: number;
  submitAttachment?: any;
}) => {
  const intl = useIntl();

  return (
    <>
      <StyledFileUploadCard>
        {fileList.length > 0 ? (
          <div className="uploaded_files_container">
            {fileList.map((file) => {
              if (file._destroy) return;

              return (
                <>
                  {submitAttachment && (
                    <Input
                      name={['custom_name', submitAttachment.name, file.id.toString()]}
                      initialValue={submitAttachment.name}
                      validations="required"
                      className="one-row-item"
                      size="middle"
                      placeholder={intl.formatMessage({ id: 'general.name' })}
                    />
                  )}
                  <Card key={file.name} className="uploaded_file">
                    <p>
                      <div className="filename">{file.blob ? file.blob.filename : file.filename}</div>
                      <span>
                        {(
                          (file.blob ? file.blob.byte_size : file.data.size ?? file.data.split(',')[1].length) /
                          (1024 * 1024)
                        ).toFixed(2)}{' '}
                        MB
                      </span>
                    </p>
                    <i className="fa-solid fa-xmark remove_btn" onClick={() => handleRemove(file)}></i>
                  </Card>
                </>
              );
            })}
          </div>
        ) : null}
      </StyledFileUploadCard>
    </>
  );
};
